<mat-radio-group [(ngModel)]="userCollection.collection_rights_id"
                 [disabled]="disabled"
                 (ngModelChange)="onChangedCollectionRights(userCollection)">
  <mat-radio-button *ngFor="let rightType of collectionRightTypes"
                    [value]="rightType.artifact_id">{{rightType.artifact_name.toUpperCase()}}</mat-radio-button>
</mat-radio-group>
